'use client';

import { useRef } from 'react';
import { useSiteConfig } from '@commons/SiteConfig';
import './_overlay.scss';
import SiteHeader from '@commons/SiteHeader/SiteHeader';

/**
 * Generic overlay component. Renders the native dialog portal.
 */
export default function Overlay({ className, children, id = 'siteheader-overlay' }) {
  const dialogRef = useRef(null);
  const { dictionary } = useSiteConfig();

  // no manual escape or scroll handling; dialog native closedBy="any" attribute handles ESC/backdrop

  return (
    <dialog id={id} ref={dialogRef} className={`Overlay ${className}`} closedby="any">
      <SiteHeader.Toggler siteHeaderOverlayId={id} togglerText={dictionary?.siteMenu?.close} />
      <div className={`Overlay__inner`}>{children}</div>
    </dialog>
  );
}
